import Loader from "./loader";
export default function SiteLoader() {
	return (
		<div className="bg-primary/20 h-screen flex flex-col justify-center">
			<p className="flex justify-center">
				<Loader />
			</p>
		</div>
	);
}
